export const SKELETON_LOADER_TYPES = {
  PRICING_CARDS: 'PRICING_CARDS',
  PRICING_TABLE: 'PRICING_TABLE',
};
